export default __webpack_public_path__ + "static/media/do.29445c6f.jpeg";